module.exports = __webpack_public_path__ + "img/zsldyh_icon.9e533bcb.png";